/**
 * ═══════════════════════════════════════════════════════════════════
 *  TourSpotlight — SVG overlay with cutout around target element
 * ═══════════════════════════════════════════════════════════════════
 *
 *  Uses an SVG <rect> + <mask> approach:
 *  - Full-screen dark overlay
 *  - Transparent cutout around the highlighted element
 *  - Smooth CSS transitions on cutout position/size
 */

import React from 'react';

const OVERLAY_STYLES = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  zIndex: 99998,
  pointerEvents: 'none',
  transition: 'opacity 0.25s ease',
};

export default function TourSpotlight({ targetRect, overlayColor = 'rgba(0, 0, 0, 0.55)', borderRadius = 8, onClick }) {
  // No target → full-screen dim overlay (for center modals)
  if (!targetRect) {
    return (
      <div
        style={{
          ...OVERLAY_STYLES,
          backgroundColor: overlayColor,
          pointerEvents: 'auto',
        }}
        onClick={onClick}
      />
    );
  }

  return (
    <svg
      style={{ ...OVERLAY_STYLES, pointerEvents: 'none' }}
    >
      <defs>
        <mask id="tour-spotlight-mask">
          {/* White = visible (overlay shows), Black = hidden (cutout) */}
          <rect x="0" y="0" width="100%" height="100%" fill="white" />
          <rect
            x={targetRect.left}
            y={targetRect.top}
            width={targetRect.width}
            height={targetRect.height}
            rx={borderRadius}
            ry={borderRadius}
            fill="black"
            style={{ transition: 'all 0.3s ease' }}
          />
        </mask>
      </defs>

      {/* Overlay with spotlight cutout */}
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        fill={overlayColor}
        mask="url(#tour-spotlight-mask)"
      />

      {/* Highlight border around cutout */}
      <rect
        x={targetRect.left}
        y={targetRect.top}
        width={targetRect.width}
        height={targetRect.height}
        rx={borderRadius}
        ry={borderRadius}
        fill="none"
        stroke="rgba(255,255,255,0.4)"
        strokeWidth="2"
        style={{ transition: 'all 0.3s ease', pointerEvents: 'none' }}
      />
    </svg>
  );
}
